import axios from 'axios';

/**
 * Fetch the server's component configuration for an instance of UserRegistration based on the given context.
 * 
 * @param {string} context 
 */
export async function fetchServerConfiguration(context) {

    const config = {
        method: 'GET',
        url: '/public/user-registration/configuration',
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            context: context
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Fetch the personal info of an invited contact (if any)
 * 
 * @param {string} context 
 */
export async function fetchInvitedContactInformation(contactId) {
    const config = {
        method: 'GET',
        url: '/public/user-registration/invited-contact',
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            contactId: contactId
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });
}

/**
 * Fetches a list of subscription item groups and packages that he user can select during subscription.
 * 
 * @param {boolean} displayFreePackages
 * @param {array} preselectedSubscriptionItemId
 */
export async function fetchPackageSelectorData(displayFreePackages = false, preselectedSubscriptionItemId = null, preselectedGroupId = null, defaultFrequency = null, promoCode = null) {

    const config = {
        method: 'GET',
        url: '/public/user-registration/available-subscription-item-groups',
        params: {
            includeFreePackages: displayFreePackages,
            preselectedSubscriptionItemId: Array.isArray(preselectedSubscriptionItemId) ? preselectedSubscriptionItemId.join(',') : null,
            preselectedGroupId: preselectedGroupId,
            defaultFrequency: defaultFrequency,
            promoCode: promoCode
        },
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Retrieves the price & tax data for the supplied registration data.
 * 
 * @param {object} registrationData 
 */
export async function fetchPriceTaxesData(registrationData) {

    /*
     * Merge regular subscription IDs (invoiceItemIDs) with secondary subscription IDs (they are all just subscription item IDs on the server side).
     * Private Construction on MERX is an example of a package selector sub component that can allow the user to choose a secondary subscription ID.
     */
    const subscriptionIds = registrationData.invoiceItemIDs.concat(registrationData.registrationModel.selectedSecondarySubscriptions.map((item) => {
        return item.id;
    })).join();

    const config = {
        method: 'GET',
        url: '/public/user-registration/price-info',
        params: {
            countryId: registrationData.registrationModel.billingInformation.countryId,
            stateProvinceId: registrationData.registrationModel.billingInformation.stateProvinceId,
            zipCode: registrationData.registrationModel.billingInformation.zipCode,
            subscriptionItemIds: subscriptionIds,
            vasItemIds: registrationData.registrationModel.subscription.vasItemIds.join(),
            selectedGroupId: registrationData.registrationModel.subscription.selectedGroup.groupId,
            selectedFrequency: registrationData.registrationModel.subscription.selectedFrequency,
            promoCodeId: registrationData.registrationModel.promotion.id
        },
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Retrieves the terms and conditions that should be displayed when capturing credit card data.
 */
export async function fetchCreditCardTermsConditionsData() {

    const config = {
        method: 'GET',
        url: '/public/user-registration/current-cc-terms-conditions',
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Retrieves the role and permission data for the selected subscriptionItemId.
 * 
 * @param {object} subscriptionItemId
 */
export async function fetchRolesAndPermissions(subscriptionItemIds) {

    const config = {
        method: 'GET',
        url: '/public/user-registration/roles-privileges',
        params: {
            subscriptionItemIds: subscriptionItemIds
        },
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

export async function fetchBillingInfoDetails() {
    const config = {
        method: 'GET',
        url: '/private/user-registration/billing-info-details',
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}
